import { dd, ddmm, ddmmyyyy } from '@/utils/date/date-to-string';
import { isToday as checkToday } from '@/utils/date/is-today';
import { isTomorrow as checkTomorrow } from '@/utils/date/is-tomorrow';

const isSameYear = (date1: Date, date2: Date): boolean => date1.getFullYear() === date2.getFullYear();

const isSameMonths = (date1: Date, date2: Date): boolean => {
  if (!isSameYear(date1, date2)) return false;

  return date1.getMonth() === date2.getMonth();
};

const getFormattedDate = (date: Date) => {
  const isToday = checkToday(date);
  const isTomorrow = checkTomorrow(date);

  if (isToday) return 'Сегодня';
  if (isTomorrow) return 'Завтра';

  return `${ddmmyyyy(date)}`;
};

export function useIntervalDates(intervalFrom: string, intervalTo: string, formatted: boolean): string {
  const from = new Date(intervalFrom);
  const to = new Date(intervalTo);

  if (!intervalTo || intervalFrom === intervalTo) return formatted ? getFormattedDate(from) : `${ddmmyyyy(from)}`;

  if (isSameMonths(from, to)) {
    return `${dd(from)} - ${ddmmyyyy(to)}`;
  }

  if (isSameYear(from, to) && !isSameMonths(from, to)) {
    return `${ddmm(from)} - ${ddmmyyyy(to)}`;
  }

  return `${ddmmyyyy(from)} - ${ddmmyyyy(to)}`;
}
